export default {
    Ao1PointSlam: '099fc378-6e25-433a-96d7-9293f59c0164',
    NationalPathwayTourTagId: 'f33fc7ff-1dea-4b8d-b93e-ba1105256cb3',
    PTT: 'ac2a49a9-d7a4-4a5a-8884-c957e1fe23cc',
};
